/**
 * credential-challenge-client-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message } from "../../general/message";
import { MessageTag } from "../../message-tag";

/**
 * A client answers a credential challenge by sending a {@link
 * CredentialChallengeClientResponse} that carries its {@linkplain
 * SecureResponse answer}. The answer is supplied as the SHA-512 hash of the
 * client-salted cleartext answer.
 */
export class CredentialChallengeClientResponse extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.CRSP_CREDENTIAL_CHALLENGE;

  public expectsReply () : boolean
  {
    return true;
  }

  /**
   * Construct a new {@link CredentialChallengeClientResponse}.
   *
   * @param response
   *        The answer to the most recent prompt, as the SHA-512 hash of the
   *        client-salted cleartext answer.
   */
  constructor (public response : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/credential-challenge-client-response.ts